import { useState, useEffect } from 'react';
import { decoratorAPI, bookingAPI } from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import './Dashboard.css';
import './DecoratorDashboard.css';

/* ══════════════════════════════════════════════════════════
   ORIGINAL CONSTANTS — untouched
   ══════════════════════════════════════════════════════════ */
const STATUS_LABELS = {
  pending: 'badge-orange', confirmed: 'badge-green',
  in_progress: 'badge-gold', completed: 'badge-green', cancelled: 'badge-red'
};
const STATUS_HINDI = {
  pending: '⏳ Pending', confirmed: '✅ Confirmed',
  in_progress: '🎨 In Progress', completed: '🎉 Completed', cancelled: '❌ Cancelled'
};
const BLAST_PACKAGES = [
  { id: 'basic', name: '🥉 Basic Blast', price: 199, reach: 'Sirf apni city ke clients', features: ['Apni city ke registered clients', 'Ek baar blast', 'Custom message'], color: '#92400e', bg: '#fffbeb' },
  { id: 'state', name: '🥈 State Blast', price: 499, reach: 'Poore CG ke clients', features: ['Poore CG ke clients', 'Ek baar blast', 'Custom message', '3 din featured listing'], color: '#1e40af', bg: '#eff6ff', popular: true },
  { id: 'premium', name: '🥇 Premium Blast', price: 999, reach: 'CG + Priority placement', features: ['Poore CG ke clients', '2 baar blast', 'Custom message + photo', '7 din featured listing', 'Admin support'], color: '#065f46', bg: '#ecfdf5' },
];
const ADS_PACKAGES = [
  { id: 'starter', name: '🚀 Starter Ad', price: 499, duration: '3 din', reach: '2,000-5,000 log', features: ['Instagram + Facebook', 'Apni city target', 'Basic design included', 'Admin manage karega'], color: '#7c3aed', bg: '#f5f3ff' },
  { id: 'growth', name: '📈 Growth Ad', price: 999, duration: '7 din', reach: '8,000-15,000 log', features: ['Instagram + Facebook', 'CG ke 5 cities', 'Professional design', 'Video ad included', 'Daily report'], color: '#0369a1', bg: '#e0f2fe', popular: true },
  { id: 'premium', name: '👑 Premium Ad', price: 1999, duration: '15 din', reach: '20,000-40,000 log', features: ['Instagram + Facebook + Reels', 'Poora CG target', 'Premium design + 2 videos', 'WhatsApp blast bhi included', 'ROI guarantee'], color: '#b45309', bg: '#fffbeb' },
];
const BOOST_PACKAGES = [
  { id: 'week', name: '⚡ Weekly Boost', price: 299, duration: '7 din', features: ['Top mein dikhoge', '⭐ Featured badge', 'Zyada clicks = zyada inquiries'], color: '#0369a1', bg: '#e0f2fe' },
  { id: 'month', name: '🔥 Monthly Boost', price: 799, duration: '30 din', features: ['Pura mahina top placement', '⭐ Featured + 🏆 Premium badge', 'Homepage pe showcase', 'Priority in search'], color: '#7c3aed', bg: '#f5f3ff', popular: true },
  { id: 'quarter', name: '💎 Quarterly Boost', price: 1999, duration: '90 din', features: ['3 mahine top placement', 'Sab badges', 'Homepage hero section', 'Social media feature', 'Dedicated profile boost'], color: '#b45309', bg: '#fffbeb' },
];
const ADMIN_WA = '919407628870';

/* ── NEW CONSTANTS ───────────────────────────────────────── */
const MONTH_NAMES = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const SUGGESTED_TAGS = [
  'Balloon Decoration','Flower Decoration','LED Lights','Stage Setup','Mandap',
  'Tent House','Photography','Catering','Car Decoration','Mehendi',
  'DJ','Band','Gate Decoration','Table Decoration','Theme Decoration',
];

/* ══════════════════════════════════════════════════════════
   ORIGINAL SUB-COMPONENTS — untouched
   ══════════════════════════════════════════════════════════ */
const PackageCard = ({ pkg, selected, onSelect }) => (
  <div onClick={() => onSelect(pkg.id)} style={{
    background: selected === pkg.id ? pkg.bg : 'white',
    border: `2px solid ${selected === pkg.id ? pkg.color : '#e2e8f0'}`,
    borderRadius: '14px', padding: '18px', cursor: 'pointer', transition: 'all 0.2s',
    position: 'relative', transform: selected === pkg.id ? 'scale(1.02)' : 'scale(1)',
    boxShadow: selected === pkg.id ? '0 4px 20px rgba(0,0,0,0.1)' : 'none'
  }}>
    {pkg.popular && <div style={{ position: 'absolute', top: '-10px', right: '12px', background: '#3b82f6', color: 'white', fontSize: '11px', fontWeight: 700, padding: '3px 10px', borderRadius: '20px' }}>⭐ Popular</div>}
    <div style={{ fontSize: '17px', fontWeight: 800, color: pkg.color, marginBottom: '4px' }}>{pkg.name}</div>
    <div style={{ fontSize: '26px', fontWeight: 900, color: '#1e293b', marginBottom: '2px' }}>₹{pkg.price}</div>
    {pkg.duration && <div style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '2px' }}>{pkg.duration}</div>}
    {pkg.reach && <div style={{ fontSize: '13px', color: '#64748b', marginBottom: '10px' }}>{pkg.reach}</div>}
    {pkg.features.map((f, i) => <div key={i} style={{ fontSize: '13px', color: '#475569', marginBottom: '4px' }}>✓ {f}</div>)}
    {selected === pkg.id && <div style={{ marginTop: '10px', padding: '6px', background: pkg.color, color: 'white', borderRadius: '8px', textAlign: 'center', fontSize: '13px', fontWeight: 700 }}>✅ Selected</div>}
  </div>
);

const HowItWorks = ({ steps, color }) => (
  <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', marginBottom: '20px' }}>
    <h4 style={{ margin: '0 0 12px' }}>📋 Kaise Kaam Karta Hai?</h4>
    {steps.map((step, i) => (
      <div key={i} style={{ display: 'flex', gap: '10px', marginBottom: '8px', alignItems: 'flex-start' }}>
        <span style={{ background: color, color: 'white', borderRadius: '50%', width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: 700, flexShrink: 0 }}>{i + 1}</span>
        <span style={{ fontSize: '14px', color: '#475569' }}>{step}</span>
      </div>
    ))}
  </div>
);

const SuccessBox = ({ onReset }) => (
  <div style={{ background: '#ecfdf5', border: '2px solid #6ee7b7', borderRadius: '12px', padding: '24px', textAlign: 'center' }}>
    <p style={{ fontSize: '32px', margin: '0 0 8px' }}>🎉</p>
    <p style={{ fontWeight: 700, color: '#065f46', fontSize: '16px', margin: '0 0 8px' }}>Request bhej di Admin ko!</p>
    <p style={{ color: '#047857', fontSize: '14px', margin: 0 }}>Payment confirm karo — phir kaam shuru hoga!</p>
    <button className="btn btn-outline" style={{ marginTop: '14px' }} onClick={onReset}>Dobara Request Karo</button>
  </div>
);

/* ══════════════════════════════════════════════════════════
   NEW FEATURE 1: PROFILE VIEWS COUNTER (Premium)
   ══════════════════════════════════════════════════════════ */
const ProfileViewsCard = ({ decorator }) => {
  const views      = decorator?.profileViews  || 0;
  const weekViews  = decorator?.weekViews     || 0;
  const todayViews = decorator?.todayViews    || 0;
  const viewTrend  = decorator?.viewTrend     || 0; // % vs last week

  // Mini sparkline — last 7 days (from decorator.viewsHistory or mock)
  const history = decorator?.viewsHistory || Array.from({ length: 7 }, (_, i) => ({
    day: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'][i],
    val: Math.floor(Math.random() * (weekViews || 10) / 4)
  }));
  const maxVal = Math.max(...history.map(h => h.val), 1);

  return (
    <div style={{
      background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #312e81 100%)',
      borderRadius: '22px',
      padding: '26px',
      marginBottom: '20px',
      color: 'white',
      position: 'relative',
      overflow: 'hidden',
      boxShadow: '0 20px 60px rgba(49, 46, 129, 0.4)',
    }}>
      {/* Background decorative orbs */}
      <div style={{ position: 'absolute', top: '-40px', right: '-40px', width: '160px', height: '160px', borderRadius: '50%', background: 'rgba(99,102,241,0.15)', filter: 'blur(30px)' }} />
      <div style={{ position: 'absolute', bottom: '-20px', left: '30px', width: '100px', height: '100px', borderRadius: '50%', background: 'rgba(139,92,246,0.12)', filter: 'blur(20px)' }} />
      <div style={{ position: 'absolute', top: '40%', left: '40%', width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(200,134,10,0.08)', filter: 'blur(25px)' }} />

      <div style={{ position: 'relative', zIndex: 1 }}>
        {/* Top row */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', gap: '12px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
              <span style={{ fontSize: '20px' }}>👁️</span>
              <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.55)', letterSpacing: '0.1em', textTransform: 'uppercase', fontWeight: 600 }}>Profile Views</span>
            </div>
            <div style={{ fontSize: '52px', fontWeight: 900, lineHeight: 1, letterSpacing: '-0.03em', background: 'linear-gradient(135deg, #fff, #c7d2fe)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              {views.toLocaleString()}
            </div>
            <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)', marginTop: '4px' }}>total all-time views</div>
          </div>

          {/* Trend badge */}
          <div style={{
            background: viewTrend >= 0 ? 'rgba(16,185,129,0.15)' : 'rgba(239,68,68,0.15)',
            border: `1px solid ${viewTrend >= 0 ? 'rgba(16,185,129,0.35)' : 'rgba(239,68,68,0.35)'}`,
            borderRadius: '14px',
            padding: '10px 16px',
            textAlign: 'center',
            backdropFilter: 'blur(10px)',
          }}>
            <div style={{ fontSize: '22px', fontWeight: 900, color: viewTrend >= 0 ? '#6ee7b7' : '#fca5a5' }}>
              {viewTrend >= 0 ? '↑' : '↓'} {Math.abs(viewTrend)}%
            </div>
            <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.45)', marginTop: '2px' }}>vs last week</div>
          </div>
        </div>

        {/* Stats row */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '22px' }}>
          {[
            { label: 'Aaj',        val: todayViews,                  icon: '🌅' },
            { label: 'Is Hafte',   val: weekViews,                   icon: '📅' },
            { label: 'Avg/Din',    val: Math.round(views / 30) || 0, icon: '📊' },
          ].map(s => (
            <div key={s.label} style={{
              background: 'rgba(255,255,255,0.07)',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '14px',
              padding: '12px 10px',
              textAlign: 'center',
            }}>
              <div style={{ fontSize: '18px', marginBottom: '4px' }}>{s.icon}</div>
              <div style={{ fontSize: '20px', fontWeight: 800 }}>{s.val}</div>
              <div style={{ fontSize: '10px', color: 'rgba(255,255,255,0.45)', marginTop: '2px' }}>{s.label}</div>
            </div>
          ))}
        </div>

        {/* Sparkline — last 7 days bar chart */}
        <div>
          <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)', marginBottom: '8px', letterSpacing: '0.06em', textTransform: 'uppercase' }}>Last 7 Days</div>
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '5px', height: '48px' }}>
            {history.map((h, i) => (
              <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', height: '100%', justifyContent: 'flex-end' }}>
                <div style={{
                  width: '100%',
                  height: `${Math.max((h.val / maxVal) * 36, 3)}px`,
                  borderRadius: '4px 4px 2px 2px',
                  background: i === history.length - 1
                    ? 'linear-gradient(180deg, #C8860A, #a16207)'
                    : 'rgba(255,255,255,0.2)',
                  boxShadow: i === history.length - 1 ? '0 2px 8px rgba(200,134,10,0.5)' : 'none',
                  transition: 'height 0.3s ease',
                }} />
                <div style={{ fontSize: '9px', color: 'rgba(255,255,255,0.35)' }}>{h.day}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer insight */}
        <div style={{
          marginTop: '18px',
          paddingTop: '14px',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}>
          <span style={{ fontSize: '14px' }}>
            {views === 0 ? '😴' : views < 50 ? '🌱' : views < 200 ? '📈' : views < 500 ? '🔥' : '👑'}
          </span>
          <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>
            {views === 0
              ? 'Profile pe koi nahi aaya abhi — profile complete karo!'
              : views < 50
              ? 'Shuruat achi hai — portfolio add karo zyada views ke liye'
              : views < 200
              ? 'Badiya! Profile boost karo zyada views ke liye'
              : views < 500
              ? 'Zabardast views — tum trending ho! 🔥'
              : 'Superstar decorator — views chart tod rahe ho! 👑'}
          </span>
        </div>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════
   NEW FEATURE 2: EARNINGS ANALYTICS — Monthly Chart
   ══════════════════════════════════════════════════════════ */
const EarningsChart = ({ bookings }) => {
  const now = new Date();

  // Last 6 months ka data
  const months = Array.from({ length: 6 }, (_, i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - (5 - i), 1);
    return { month: d.getMonth(), year: d.getFullYear(), label: MONTH_NAMES[d.getMonth()] };
  });

  const data = months.map(m => {
    const completed = bookings.filter(b =>
      b.status === 'completed' &&
      new Date(b.eventDate).getMonth() === m.month &&
      new Date(b.eventDate).getFullYear() === m.year
    );
    const earned = completed.reduce((s, b) => s + (b.decoratorAmount || 0), 0);
    const bookingCount = bookings.filter(b =>
      new Date(b.eventDate).getMonth() === m.month &&
      new Date(b.eventDate).getFullYear() === m.year
    ).length;
    return { ...m, earned, bookingCount };
  });

  const maxEarned  = Math.max(...data.map(d => d.earned), 1);
  const totalEarned = data.reduce((s, d) => s + d.earned, 0);
  const avgEarned  = Math.round(totalEarned / 6);
  const bestIdx    = data.reduce((bi, d, i) => d.earned > data[bi].earned ? i : bi, 0);
  const isCurrentMonth = (d) => d.month === now.getMonth() && d.year === now.getFullYear();

  return (
    <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '20px', padding: '24px', marginBottom: '20px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '22px', flexWrap: 'wrap', gap: '12px' }}>
        <div>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 800, color: '#1e293b' }}>📊 Kamai ka Hisaab</h3>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#94a3b8' }}>Pichle 6 mahine</p>
        </div>
        <div style={{ display: 'flex', gap: '16px' }}>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '10px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>6M Total</div>
            <div style={{ fontSize: '20px', fontWeight: 900, color: '#10b981' }}>₹{totalEarned.toLocaleString()}</div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: '10px', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Avg/Month</div>
            <div style={{ fontSize: '20px', fontWeight: 900, color: '#3b82f6' }}>₹{avgEarned.toLocaleString()}</div>
          </div>
        </div>
      </div>

      {/* Chart */}
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', height: '140px', padding: '0 4px' }}>
        {data.map((d, i) => {
          const heightPx = maxEarned > 0 ? Math.max((d.earned / maxEarned) * 110, d.earned > 0 ? 10 : 4) : 4;
          const isBest   = i === bestIdx;
          const isCurrent = isCurrentMonth(d);

          return (
            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', height: '100%', justifyContent: 'flex-end' }}>
              {/* Value label */}
              {d.earned > 0 && (
                <div style={{ fontSize: '10px', fontWeight: 700, color: isBest ? '#10b981' : '#94a3b8', whiteSpace: 'nowrap' }}>
                  {d.earned >= 1000 ? `₹${(d.earned / 1000).toFixed(1)}k` : `₹${d.earned}`}
                </div>
              )}
              {/* Bar */}
              <div style={{ position: 'relative', width: '100%' }}>
                {isBest && d.earned > 0 && (
                  <div style={{ position: 'absolute', top: `-${heightPx + 14}px`, left: '50%', transform: 'translateX(-50%)', fontSize: '13px' }}>🏆</div>
                )}
                <div style={{
                  width: '100%',
                  height: `${heightPx}px`,
                  borderRadius: '8px 8px 4px 4px',
                  background: isBest
                    ? 'linear-gradient(180deg, #10b981, #059669)'
                    : isCurrent
                    ? 'linear-gradient(180deg, #C8860A, #a16207)'
                    : 'linear-gradient(180deg, #e2e8f0, #cbd5e1)',
                  boxShadow: isBest
                    ? '0 4px 14px rgba(16,185,129,0.35)'
                    : isCurrent
                    ? '0 4px 14px rgba(200,134,10,0.3)'
                    : 'none',
                  transition: 'height 0.4s ease',
                }} />
              </div>
              {/* Month label */}
              <div style={{ fontSize: '11px', fontWeight: isCurrent ? 700 : 500, color: isCurrent ? '#C8860A' : '#94a3b8' }}>{d.label}</div>
              {/* Booking count */}
              {d.bookingCount > 0 && (
                <div style={{ fontSize: '10px', color: '#cbd5e1' }}>{d.bookingCount}b</div>
              )}
            </div>
          );
        })}
      </div>

      {/* Legend */}
      <div style={{ display: 'flex', gap: '16px', marginTop: '16px', paddingTop: '14px', borderTop: '1px solid #f1f5f9', flexWrap: 'wrap' }}>
        {[
          { grad: 'linear-gradient(135deg, #10b981, #059669)', label: `Best Month (${data[bestIdx]?.label})` },
          { grad: 'linear-gradient(135deg, #C8860A, #a16207)', label: 'Current Month' },
          { grad: 'linear-gradient(135deg, #e2e8f0, #cbd5e1)', label: 'Baaki Months' },
        ].map(l => (
          <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <div style={{ width: '12px', height: '12px', borderRadius: '3px', background: l.grad }} />
            <span style={{ fontSize: '12px', color: '#64748b' }}>{l.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════
   NEW FEATURE 3: AVAILABILITY CALENDAR
   ══════════════════════════════════════════════════════════ */
const AvailabilityCalendar = ({ blockedDates, onToggleDate }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const year      = currentMonth.getFullYear();
  const month     = currentMonth.getMonth();
  const firstDay  = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const todayStr  = new Date().toDateString();

  const toDateStr = (day) =>
    `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

  const isPast = (day) => {
    const d = new Date(year, month, day);
    d.setHours(0,0,0,0);
    const t = new Date(); t.setHours(0,0,0,0);
    return d < t;
  };

  return (
    <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '20px', padding: '24px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <div>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 800, color: '#1e293b' }}>📅 Availability Calendar</h3>
          <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#94a3b8' }}>Date pe click karo block / unblock karne ke liye</p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button onClick={() => setCurrentMonth(new Date(year, month - 1, 1))} style={{ width: '32px', height: '32px', border: '1px solid #e2e8f0', borderRadius: '8px', background: 'white', cursor: 'pointer', fontSize: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>‹</button>
          <span style={{ fontWeight: 700, color: '#1e293b', minWidth: '110px', textAlign: 'center', fontSize: '14px' }}>{MONTH_NAMES[month]} {year}</span>
          <button onClick={() => setCurrentMonth(new Date(year, month + 1, 1))} style={{ width: '32px', height: '32px', border: '1px solid #e2e8f0', borderRadius: '8px', background: 'white', cursor: 'pointer', fontSize: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>›</button>
        </div>
      </div>

      {/* Day names */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '3px', marginBottom: '4px' }}>
        {['S','M','T','W','T','F','S'].map((d, i) => (
          <div key={i} style={{ textAlign: 'center', fontSize: '11px', fontWeight: 700, color: '#94a3b8', padding: '4px 0' }}>{d}</div>
        ))}
      </div>

      {/* Days */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '3px' }}>
        {Array.from({ length: firstDay }).map((_, i) => <div key={`e${i}`} />)}
        {Array.from({ length: daysInMonth }, (_, i) => i + 1).map(day => {
          const ds      = toDateStr(day);
          const blocked = blockedDates.includes(ds);
          const past    = isPast(day);
          const isToday = new Date(year, month, day).toDateString() === todayStr;

          return (
            <div
              key={day}
              onClick={() => !past && onToggleDate(ds)}
              title={blocked ? 'Blocked — click to unblock' : past ? 'Past date' : 'Available — click to block'}
              style={{
                aspectRatio: '1', display: 'flex', alignItems: 'center', justifyContent: 'center',
                borderRadius: '10px', fontSize: '13px', fontWeight: isToday ? 800 : 500,
                cursor: past ? 'default' : 'pointer', transition: 'all 0.15s',
                background: blocked
                  ? 'linear-gradient(135deg, #fee2e2, #fecaca)'
                  : isToday
                  ? 'linear-gradient(135deg, #C8860A, #a16207)'
                  : past
                  ? '#f8fafc'
                  : '#f0fdf4',
                color: blocked ? '#dc2626' : isToday ? 'white' : past ? '#d1d5db' : '#166534',
                border: blocked ? '1.5px solid #fca5a5' : isToday ? '1.5px solid transparent' : '1.5px solid transparent',
                boxShadow: blocked ? '0 2px 6px rgba(220,38,38,0.12)' : isToday ? '0 3px 10px rgba(200,134,10,0.3)' : 'none',
                opacity: past && !isToday ? 0.45 : 1,
              }}
            >
              {blocked ? '✕' : day}
            </div>
          );
        })}
      </div>

      {/* Legend */}
      <div style={{ display: 'flex', gap: '14px', marginTop: '16px', paddingTop: '14px', borderTop: '1px solid #f1f5f9', flexWrap: 'wrap', alignItems: 'center' }}>
        {[
          { bg: '#f0fdf4', border: 'transparent', label: 'Available' },
          { bg: '#fee2e2', border: '#fca5a5',    label: 'Blocked' },
          { bg: 'linear-gradient(135deg,#C8860A,#a16207)', border: 'transparent', label: 'Today' },
        ].map(l => (
          <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <div style={{ width: '14px', height: '14px', borderRadius: '4px', background: l.bg, border: `1.5px solid ${l.border}` }} />
            <span style={{ fontSize: '11px', color: '#64748b' }}>{l.label}</span>
          </div>
        ))}
        <span style={{ marginLeft: 'auto', fontSize: '12px', color: '#94a3b8' }}>{blockedDates.length} dates blocked</span>
      </div>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════
   NEW FEATURE 4 & 5: ADVANCED PROFILE + TAGS
   ══════════════════════════════════════════════════════════ */
const AdvancedProfile = ({ decorator, onSave }) => {
  const [form, setForm] = useState({
    instagram:    decorator?.instagram    || '',
    facebook:     decorator?.facebook     || '',
    website:      decorator?.website      || '',
    teamSize:     decorator?.teamSize     || '',
    responseTime: decorator?.responseTime || '1-2 hours',
    tags:         decorator?.tags         || [],
  });
  const [saving, setSaving]     = useState(false);
  const [tagInput, setTagInput] = useState('');

  const addTag = (tag) => {
    const t = tag.trim();
    if (!t || form.tags.includes(t) || form.tags.length >= 10) return;
    setForm(f => ({ ...f, tags: [...f.tags, t] }));
    setTagInput('');
  };
  const removeTag = (tag) => setForm(f => ({ ...f, tags: f.tags.filter(t => t !== tag) }));

  const handleSave = async () => {
    setSaving(true);
    try {
      await decoratorAPI.updateProfile(form);
      toast.success('Profile update ho gaya! ✅');
      onSave && onSave();
    } catch { toast.error('Save nahi hua, dobara try karo'); }
    finally { setSaving(false); }
  };

  const inp = {
    width: '100%', padding: '10px 14px',
    border: '1.5px solid #e2e8f0', borderRadius: '10px',
    fontFamily: 'inherit', fontSize: '14px', color: '#1e293b',
    outline: 'none', background: 'white', transition: 'border-color 0.2s',
    boxSizing: 'border-box',
  };

  return (
    <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '20px', padding: '24px', marginBottom: '20px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>
      <h3 style={{ margin: '0 0 4px', fontSize: '18px', fontWeight: 800, color: '#1e293b' }}>✏️ Advanced Profile</h3>
      <p style={{ margin: '0 0 22px', fontSize: '13px', color: '#94a3b8' }}>Social links, team details aur better search ke liye tags</p>

      {/* Social links */}
      <div style={{ marginBottom: '22px' }}>
        <div style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>🔗 Social Media & Website</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
          {[
            { key: 'instagram', icon: '📸', label: 'Instagram', ph: 'instagram.com/yourpage', col: '1' },
            { key: 'facebook',  icon: '👥', label: 'Facebook',  ph: 'facebook.com/yourpage',  col: '1' },
            { key: 'website',   icon: '🌐', label: 'Website',   ph: 'yourwebsite.com',         col: '1 / -1' },
          ].map(f => (
            <div key={f.key} style={{ gridColumn: f.col }}>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#475569', display: 'block', marginBottom: '6px' }}>{f.icon} {f.label}</label>
              <input
                style={inp}
                placeholder={f.ph}
                value={form[f.key]}
                onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))}
                onFocus={e => e.target.style.borderColor = '#C8860A'}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Team details */}
      <div style={{ marginBottom: '22px' }}>
        <div style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>👥 Team Details</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
          <div>
            <label style={{ fontSize: '12px', fontWeight: 600, color: '#475569', display: 'block', marginBottom: '6px' }}>👥 Team Size</label>
            <select style={inp} value={form.teamSize} onChange={e => setForm(p => ({ ...p, teamSize: e.target.value }))}>
              <option value="">Select karo</option>
              {['Solo (sirf main)', '2-5 log', '6-10 log', '11-20 log', '20+ log'].map(o => <option key={o}>{o}</option>)}
            </select>
          </div>
          <div>
            <label style={{ fontSize: '12px', fontWeight: 600, color: '#475569', display: 'block', marginBottom: '6px' }}>⚡ Response Time</label>
            <select style={inp} value={form.responseTime} onChange={e => setForm(p => ({ ...p, responseTime: e.target.value }))}>
              {['Within 1 hour', '1-2 hours', '2-4 hours', 'Same day', 'Within 24 hours'].map(o => <option key={o}>{o}</option>)}
            </select>
          </div>
        </div>
      </div>

      {/* Tags */}
      <div style={{ marginBottom: '24px' }}>
        <div style={{ fontSize: '11px', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '12px' }}>
          🏷️ Search Tags &nbsp;<span style={{ color: '#94a3b8', fontWeight: 400, textTransform: 'none', fontSize: '11px' }}>({form.tags.length}/10) — clients search mein miloge</span>
        </div>

        {/* Selected tags */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '7px', marginBottom: '12px', minHeight: '30px' }}>
          {form.tags.length === 0
            ? <span style={{ fontSize: '13px', color: '#cbd5e1', fontStyle: 'italic' }}>Koi tag nahi — neeche se add karo</span>
            : form.tags.map(tag => (
              <span key={tag} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', background: '#fef3c7', border: '1.5px solid #fcd34d', borderRadius: '100px', padding: '4px 12px', fontSize: '12px', fontWeight: 600, color: '#92400e' }}>
                {tag}
                <button onClick={() => removeTag(tag)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#b45309', fontSize: '15px', lineHeight: 1, padding: 0, marginTop: '-1px' }}>×</button>
              </span>
            ))
          }
        </div>

        {/* Custom input */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
          <input
            style={{ ...inp, flex: 1 }}
            placeholder="Custom tag type karo aur Enter dabao..."
            value={tagInput}
            onChange={e => setTagInput(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), addTag(tagInput))}
            onFocus={e => e.target.style.borderColor = '#C8860A'}
            onBlur={e => e.target.style.borderColor = '#e2e8f0'}
          />
          <button onClick={() => addTag(tagInput)} style={{ padding: '10px 18px', background: '#C8860A', color: 'white', border: 'none', borderRadius: '10px', fontWeight: 700, fontSize: '13px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
            + Add
          </button>
        </div>

        {/* Suggested tags */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
          {SUGGESTED_TAGS.filter(t => !form.tags.includes(t)).map(tag => (
            <button
              key={tag}
              onClick={() => addTag(tag)}
              style={{ padding: '4px 10px', background: '#f8fafc', border: '1.5px dashed #cbd5e1', borderRadius: '100px', fontSize: '12px', color: '#64748b', cursor: 'pointer', transition: 'all 0.15s' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = '#C8860A'; e.currentTarget.style.color = '#C8860A'; e.currentTarget.style.background = '#fffbeb'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = '#cbd5e1'; e.currentTarget.style.color = '#64748b'; e.currentTarget.style.background = '#f8fafc'; }}
            >
              + {tag}
            </button>
          ))}
        </div>
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        style={{ width: '100%', padding: '14px', background: saving ? '#94a3b8' : 'linear-gradient(135deg, #C8860A, #a16207)', color: 'white', border: 'none', borderRadius: '12px', fontWeight: 700, fontSize: '15px', cursor: saving ? 'not-allowed' : 'pointer', transition: 'all 0.2s' }}
      >
        {saving ? '⏳ Save ho raha hai...' : '💾 Profile Save Karo'}
      </button>
    </div>
  );
};

/* ══════════════════════════════════════════════════════════
   MAIN COMPONENT
   ══════════════════════════════════════════════════════════ */
export default function DecoratorDashboard() {
  const { user } = useAuth();
  const [data, setData]                       = useState(null);
  const [loading, setLoading]                 = useState(true);
  const [activeTab, setActiveTab]             = useState('overview'); // NEW: default tab changed
  const [uploading, setUploading]             = useState(false);
  const [selectedFile, setSelectedFile]       = useState(null);
  const [caption, setCaption]                 = useState('');
  const [filterStatus, setFilterStatus]       = useState('all');
  const [deletingId, setDeletingId]           = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [blastMessage, setBlastMessage]       = useState('');
  const [blastSubmitting, setBlastSubmitting] = useState(false);
  const [blastRequested, setBlastRequested]   = useState(false);
  const [selectedAd, setSelectedAd]           = useState(null);
  const [adSubmitting, setAdSubmitting]       = useState(false);
  const [adRequested, setAdRequested]         = useState(false);
  const [selectedBoost, setSelectedBoost]     = useState(null);
  const [boostSubmitting, setBoostSubmitting] = useState(false);
  const [boostRequested, setBoostRequested]   = useState(false);
  // NEW states
  const [blockedDates, setBlockedDates]       = useState([]);
  const [savingDates, setSavingDates]         = useState(false);

  const fetchDashboard = () => {
    decoratorAPI.getDashboard()
      .then(({ data }) => {
        setData(data);
        setBlockedDates(data?.decorator?.blockedDates || []); // NEW
      })
      .catch(() => toast.error('Data load nahi hua'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchDashboard(); }, []);

  useEffect(() => {
    if (data?.decorator) {
      const dec = data.decorator;
      setBlastMessage(`Namaskar! 🙏\n\nKya aapka koi event aane wala hai? 🎉\n\nMain hoon *${dec.businessName}* — ${dec.city} ka trusted decorator!\n\nHum karte hain:\n${(dec.services || []).slice(0, 4).map(s => `✅ ${s}`).join('\n')}\n\n💰 Budget: ₹${(dec.priceRange?.min || 10000).toLocaleString()} se shuru\n⭐ Rating: ${dec.rating || 4.5}/5\n\n📲 Book karo:\ndecorbhub-ruddy.vercel.app\n\n📞 Direct: ${dec.phone || 'Contact karo'}`);
    }
  }, [data]);

  // ── Original handlers — untouched ──────────────────────
  const handleStatusUpdate = async (bookingId, status) => {
    try { await bookingAPI.updateStatus(bookingId, status); toast.success('Status update ho gaya!'); fetchDashboard(); }
    catch { toast.error('Status update nahi hua'); }
  };

  const handleDeleteBooking = async (bookingId) => {
    if (!window.confirm('Delete karna chahte ho?')) return;
    setDeletingId(bookingId);
    try { await bookingAPI.delete(bookingId); toast.success('Deleted!'); fetchDashboard(); }
    catch { toast.error('Delete nahi hua'); }
    finally { setDeletingId(null); }
  };

 const handlePortfolioUpload = async (e) => {
  e.preventDefault();
  if (!selectedFile) return toast.error('Photo ya video select karo');
  
  // 50MB size check
  const MAX_SIZE = 50 * 1024 * 1024;
  if (selectedFile.size > MAX_SIZE) return toast.error('File 50MB se badi hai!');

  setUploading(true);
  try {
    const formData = new FormData();
    const isVideo = selectedFile.type.startsWith('video/');
   formData.append('file', selectedFile);
    formData.append('caption', caption);
    formData.append('mediaType', isVideo ? 'video' : 'image');
    await decoratorAPI.uploadPortfolio(formData);
    toast.success(isVideo ? 'Video upload ho gayi! 🎥' : 'Photo upload ho gayi! 📸');
    setSelectedFile(null); setCaption(''); fetchDashboard();
  } catch { toast.error('Upload nahi hua'); }
  finally { setUploading(false); }
};

  const handleDeletePhoto = async (photoId) => {
    if (!window.confirm('Photo delete karna chahte ho?')) return;
    try { await decoratorAPI.deletePortfolio(photoId); toast.success('Deleted'); fetchDashboard(); }
    catch { toast.error('Delete nahi hua'); }
  };

  const sendWhatsApp = (title, body) => {
    const text = encodeURIComponent(body);
    window.open(`https://wa.me/${ADMIN_WA}?text=${text}`, '_blank');
  };

  const handleBlastRequest = () => {
    if (!selectedPackage) return toast.error('Package select karo');
    if (!blastMessage.trim()) return toast.error('Message likho');
    setBlastSubmitting(true);
    const pkg = BLAST_PACKAGES.find(p => p.id === selectedPackage);
    sendWhatsApp('Blast', `🎯 *WhatsApp Blast Request*\n\nDecorator: ${data?.decorator?.businessName}\nPackage: ${pkg?.name} (₹${pkg?.price})\nCity: ${data?.decorator?.city}\nPhone: ${data?.decorator?.phone}\n\nMessage:\n${blastMessage}\n\nPayment ke baad blast karo! 🙏`);
    setBlastRequested(true);
    toast.success('Request bhej di! 🎉');
    setBlastSubmitting(false);
  };

  const handleAdRequest = () => {
    if (!selectedAd) return toast.error('Package select karo');
    setAdSubmitting(true);
    const pkg = ADS_PACKAGES.find(p => p.id === selectedAd);
    const dec = data?.decorator;
    sendWhatsApp('Ad', `📢 *Instagram/Facebook Ad Request*\n\nDecorator: ${dec?.businessName}\nPackage: ${pkg?.name} (₹${pkg?.price})\nDuration: ${pkg?.duration}\nReach: ${pkg?.reach}\nCity: ${dec?.city}\nPhone: ${dec?.phone}\nServices: ${dec?.services?.slice(0, 3).join(', ')}\n\nPayment ke baad ad shuru karo! 🙏`);
    setAdRequested(true);
    toast.success('Ad request bhej di! 🎉');
    setAdSubmitting(false);
  };

  const handleBoostRequest = () => {
    if (!selectedBoost) return toast.error('Package select karo');
    setBoostSubmitting(true);
    const pkg = BOOST_PACKAGES.find(p => p.id === selectedBoost);
    const dec = data?.decorator;
    sendWhatsApp('Boost', `⭐ *Profile Boost Request*\n\nDecorator: ${dec?.businessName}\nPackage: ${pkg?.name} (₹${pkg?.price})\nDuration: ${pkg?.duration}\nCity: ${dec?.city}\nPhone: ${dec?.phone}\n\nFeatured listing activate karo! 🙏`);
    setBoostRequested(true);
    toast.success('Boost request bhej di! 🎉');
    setBoostSubmitting(false);
  };

  // NEW handlers
  const handleToggleDate = (dateStr) => {
    setBlockedDates(prev =>
      prev.includes(dateStr) ? prev.filter(d => d !== dateStr) : [...prev, dateStr]
    );
  };

  const handleSaveDates = async () => {
    setSavingDates(true);
    try {
      await decoratorAPI.updateProfile({ blockedDates });
      toast.success('Dates save ho gayi! ✅');
    } catch { toast.error('Save nahi hua'); }
    finally { setSavingDates(false); }
  };

  if (loading) return <div className="page"><div className="spinner" /></div>;

  const { decorator, bookings = [], stats = {} } = data || {};
  const filteredBookings = filterStatus === 'all' ? bookings : bookings.filter(b => b.status === filterStatus);
  const thisMonth = new Date().getMonth();
  const thisYear  = new Date().getFullYear();
  const thisMonthEarnings = bookings
    .filter(b => b.status === 'completed' && new Date(b.eventDate).getMonth() === thisMonth && new Date(b.eventDate).getFullYear() === thisYear)
    .reduce((sum, b) => sum + (b.decoratorAmount || 0), 0);
  const completedCount    = bookings.filter(b => b.status === 'completed').length;
  const pendingCommission = bookings.filter(b => b.status === 'completed').reduce((sum, b) => sum + (b.commissionAmount || 0), 0);

  // All tabs
  const TABS = [
    { key: 'overview',  label: '🏠 Overview' },                                         // NEW
    { key: 'bookings',  label: `📋 Bookings (${bookings.length})` },
    { key: 'portfolio', label: `📸 Portfolio (${decorator?.portfolio?.length || 0})` },
    { key: 'calendar',  label: '📅 Availability' },                                      // NEW
    { key: 'profile',   label: '✏️ Profile' },                                           // NEW
    { key: 'blast',     label: '📱 WhatsApp Blast' },
    { key: 'ads',       label: '📢 Run Ads' },
    { key: 'boost',     label: '⭐ Profile Boost' },
  ];

  return (
    <div className="dashboard-page page">
      <div className="container">

        {/* ── HEADER — original ── */}
        <div className="dash-header">
          <div>
            <h1>Namaste, {user?.name}! 🎨</h1>
            <p>{decorator?.businessName} — {decorator?.isVerified ? '✅ Verified' : '⏳ Verification Pending'}</p>
          </div>
        </div>

        {!decorator?.isVerified && (
          <div className="verify-alert">⏳ Account verification pending hai. Admin jald verify karega.</div>
        )}

        {/* ── STATS — original ── */}
        <div className="dash-stats">
          {[
            { icon: '📋', label: 'Total Bookings', value: stats.total || 0 },
            { icon: '⏳', label: 'Pending',         value: stats.pending || 0 },
            { icon: '✅', label: 'Confirmed',        value: stats.confirmed || 0 },
            { icon: '💰', label: 'Total Earnings',   value: `₹${((stats.earnings || 0) / 1000).toFixed(1)}k` },
          ].map(s => (
            <div key={s.label} className="stat-tile card">
              <span className="stat-icon">{s.icon}</span>
              <span className="stat-val">{s.value}</span>
              <span className="stat-lbl">{s.label}</span>
            </div>
          ))}
        </div>

        {/* ── QUICK EARNINGS — original ── */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
          <div style={{ background: 'linear-gradient(135deg, #ecfdf5, #d1fae5)', border: '1px solid #6ee7b7', borderRadius: '12px', padding: '16px' }}>
            <p style={{ color: '#065f46', fontSize: '13px', margin: '0 0 4px' }}>🗓️ Is Mahine Ki Kamai</p>
            <p style={{ color: '#047857', fontSize: '22px', fontWeight: 800, margin: 0 }}>₹{thisMonthEarnings.toLocaleString()}</p>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #fff7ed, #ffedd5)', border: '1px solid #fdba74', borderRadius: '12px', padding: '16px' }}>
            <p style={{ color: '#9a3412', fontSize: '13px', margin: '0 0 4px' }}>⚠️ Pending Commission</p>
            <p style={{ color: '#c2410c', fontSize: '22px', fontWeight: 800, margin: 0 }}>₹{pendingCommission.toLocaleString()}</p>
            <p style={{ color: '#9a3412', fontSize: '11px', margin: '2px 0 0' }}>Admin ko dena hai</p>
          </div>
        </div>

        {/* ── COMMISSION — original ── */}
        <div style={{ background: 'linear-gradient(135deg, #fffbeb, #fef3c7)', border: '2px solid #f59e0b', borderRadius: '14px', padding: '20px', marginBottom: '24px' }}>
          <h3 style={{ color: '#92400e', margin: '0 0 12px' }}>📊 Platform Commission</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '12px' }}>
            {[{ val: '3%', label: 'Platform', color: '#ef4444' }, { val: '97%', label: 'Tumhara', color: '#10b981' }, { val: `₹${(decorator?.pendingCommission || 0).toLocaleString()}`, label: 'Pending', color: '#3b82f6' }].map(s => (
              <div key={s.label} style={{ textAlign: 'center', padding: '12px', background: 'white', borderRadius: '10px' }}>
                <div style={{ fontSize: '22px', fontWeight: 800, color: s.color }}>{s.val}</div>
                <div style={{ fontSize: '12px', color: '#64748b' }}>{s.label}</div>
              </div>
            ))}
          </div>
          <div style={{ fontSize: '13px', color: '#92400e' }}>
            <strong>Example:</strong> ₹50,000 booking → Apka = <strong>₹48,500</strong> | Platform = <strong>₹1,500</strong>
          </div>
        </div>

        {/* ── TABS — updated with new tabs ── */}
        <div className="tabs" style={{ marginBottom: '24px', flexWrap: 'wrap', gap: '8px' }}>
          {TABS.map(tab => (
            <button key={tab.key} className={`tab-btn ${activeTab === tab.key ? 'active' : ''}`} onClick={() => setActiveTab(tab.key)}>
              {tab.label}
            </button>
          ))}
        </div>

        {/* ════════════════════════════════════════════════
            NEW TAB: OVERVIEW — Views + Earnings chart
            ════════════════════════════════════════════════ */}
        {activeTab === 'overview' && (
          <div>
            <ProfileViewsCard decorator={decorator} />
            <EarningsChart bookings={bookings} />
          </div>
        )}

        {/* ════════════════════════════════════════════════
            ORIGINAL TAB: BOOKINGS — untouched
            ════════════════════════════════════════════════ */}
        {activeTab === 'bookings' && (
          <>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
              {['all', 'pending', 'confirmed', 'in_progress', 'completed', 'cancelled'].map(s => (
                <button key={s} onClick={() => setFilterStatus(s)} style={{ padding: '6px 14px', borderRadius: '20px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: 600, background: filterStatus === s ? '#C8860A' : '#f1f5f9', color: filterStatus === s ? 'white' : '#64748b' }}>
                  {s === 'all' ? `Sab (${bookings.length})` : STATUS_HINDI[s]}{s !== 'all' && ` (${bookings.filter(b => b.status === s).length})`}
                </button>
              ))}
            </div>
            {filteredBookings.length === 0 ? <div className="empty-state"><h3>Koi booking nahi</h3></div> : (
              <div className="bookings-list">
                {filteredBookings.map(booking => (
                  <div key={booking._id} className="booking-row card">
                    <div className="booking-info">
                      <div className="booking-main">
                        <h3>{booking.eventType}</h3>
                        <span className={`badge ${STATUS_LABELS[booking.status]}`}>{booking.status}</span>
                      </div>
                      <p>👤 {booking.client?.name} • 📞 {booking.client?.phone}</p>
                      <p>📅 {new Date(booking.eventDate).toLocaleDateString('hi-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
                      <p>📍 {booking.venue?.address}</p>
                      {booking.requirements && <p>📝 {booking.requirements}</p>}
                    </div>
                    <div className="booking-right">
                      <div className="booking-amount"><span>Total</span><strong>₹{booking.totalAmount?.toLocaleString()}</strong></div>
                      <div className="booking-amount"><span>Platform (3%)</span><span style={{ color: '#f59e0b', fontWeight: 600 }}>-₹{booking.commissionAmount?.toLocaleString()}</span></div>
                      <div className="booking-amount"><span>Apka (97%)</span><strong style={{ color: '#10b981' }}>₹{booking.decoratorAmount?.toLocaleString()}</strong></div>
                      <div className="status-actions">
                        {booking.status === 'pending' && (<>
                          <button className="btn btn-primary btn-sm" onClick={() => handleStatusUpdate(booking._id, 'confirmed')}>✓ Confirm</button>
                          <button className="btn btn-outline btn-sm" style={{ borderColor: 'var(--error)', color: 'var(--error)' }} onClick={() => handleStatusUpdate(booking._id, 'cancelled')}>✕ Decline</button>
                        </>)}
                        {booking.status === 'confirmed' && (<>
                          <button className="btn btn-primary btn-sm" onClick={() => handleStatusUpdate(booking._id, 'in_progress')}>🎨 Start Karo</button>
                          <Link to="/chat" className="btn btn-outline btn-sm">💬 Chat</Link>
                        </>)}
                        {booking.status === 'in_progress' && (<>
                          <button className="btn btn-primary btn-sm" onClick={() => handleStatusUpdate(booking._id, 'completed')}>🎉 Complete Karo</button>
                          <Link to="/chat" className="btn btn-outline btn-sm">💬 Chat</Link>
                        </>)}
                        {(booking.status === 'completed' || booking.status === 'cancelled') && (
                          <button className="btn btn-sm" style={{ background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' }} onClick={() => handleDeleteBooking(booking._id)} disabled={deletingId === booking._id}>
                            {deletingId === booking._id ? '⏳...' : '🗑️ Delete'}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {/* ════════════════════════════════════════════════
            ORIGINAL TAB: PORTFOLIO — untouched
            ════════════════════════════════════════════════ */}
        {activeTab === 'portfolio' && (
          <div className="portfolio-section">
            <div className="upload-form card">
              <h3>Nayi Photo Ya Video Add Karo</h3>
              <form onSubmit={handlePortfolioUpload}>
                <div className="form-group"><label>Photo Select Karo</label><input type="file" accept="image/*,video/*" className="input" onChange={e => setSelectedFile(e.target.files[0])} /></div>
                <div className="form-group"><label>Caption (optional)</label><input className="input" placeholder="Jaise: Shaadi decoration 2024" value={caption} onChange={e => setCaption(e.target.value)} /></div>
                <button className="btn btn-primary" type="submit" disabled={uploading}>{uploading ? 'Upload ho raha hai...' : '📸 Upload Karo'}</button>
              </form>
            </div>
            <div className="portfolio-manage-grid">
              {decorator?.portfolio?.map(photo => (
                <div key={photo._id} className="portfolio-manage-item">
                 {photo.mediaType === 'video' || photo.image?.includes('/video/') ? (
  <video
    src={photo.image}
    controls
    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
  />
) : (
  <img src={photo.image} alt={photo.caption} />
)}
                  <div className="photo-overlay"><p>{photo.caption}</p><button className="delete-photo-btn" onClick={() => handleDeletePhoto(photo._id)}>🗑️ Delete</button></div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* ════════════════════════════════════════════════
            NEW TAB: AVAILABILITY CALENDAR
            ════════════════════════════════════════════════ */}
        {activeTab === 'calendar' && (
          <div>
            <AvailabilityCalendar blockedDates={blockedDates} onToggleDate={handleToggleDate} />

            {/* Blocked dates list */}
            {blockedDates.length > 0 && (
              <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '20px', margin: '16px 0' }}>
                <h4 style={{ margin: '0 0 12px', color: '#1e293b', fontSize: '15px' }}>🔴 Blocked Dates ({blockedDates.length})</h4>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {[...blockedDates].sort().map(d => (
                    <span key={d} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: '8px', padding: '4px 10px', fontSize: '12px', color: '#dc2626', fontWeight: 600 }}>
                      {new Date(d + 'T00:00:00').toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })}
                      <button onClick={() => handleToggleDate(d)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#dc2626', fontSize: '15px', padding: 0, lineHeight: 1, marginTop: '-1px' }}>×</button>
                    </span>
                  ))}
                </div>
              </div>
            )}

            <button
              onClick={handleSaveDates}
              disabled={savingDates}
              style={{ width: '100%', padding: '14px', background: savingDates ? '#94a3b8' : 'linear-gradient(135deg, #C8860A, #a16207)', color: 'white', border: 'none', borderRadius: '12px', fontWeight: 700, fontSize: '15px', cursor: savingDates ? 'not-allowed' : 'pointer', marginTop: '8px' }}
            >
              {savingDates ? '⏳ Save ho raha hai...' : '💾 Availability Save Karo'}
            </button>
          </div>
        )}

        {/* ════════════════════════════════════════════════
            NEW TAB: ADVANCED PROFILE + TAGS
            ════════════════════════════════════════════════ */}
        {activeTab === 'profile' && (
          <AdvancedProfile decorator={decorator} onSave={fetchDashboard} />
        )}

        {/* ════════════════════════════════════════════════
            ORIGINAL TAB: WHATSAPP BLAST — untouched
            ════════════════════════════════════════════════ */}
        {activeTab === 'blast' && (
          <div>
            <div style={{ background: 'linear-gradient(135deg, #dcfce7, #bbf7d0)', border: '1px solid #86efac', borderRadius: '14px', padding: '20px', marginBottom: '24px' }}>
              <h3 style={{ color: '#166534', margin: '0 0 8px' }}>📱 WhatsApp Blast — Zyada Clients Pao!</h3>
              <p style={{ color: '#15803d', margin: 0, fontSize: '14px' }}>DecorHub ke registered clients ko seedha WhatsApp pe bhejo 🚀</p>
            </div>
            <h3 style={{ marginBottom: '16px' }}>Package Chuno:</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '14px', marginBottom: '24px' }}>
              {BLAST_PACKAGES.map(pkg => <PackageCard key={pkg.id} pkg={pkg} selected={selectedPackage} onSelect={setSelectedPackage} />)}
            </div>
            <div className="card" style={{ marginBottom: '20px' }}>
              <h3 style={{ marginBottom: '12px' }}>✍️ Message Edit Karo</h3>
              <textarea className="input" rows={10} value={blastMessage} onChange={e => setBlastMessage(e.target.value)} style={{ fontFamily: 'monospace', fontSize: '13px', lineHeight: 1.6 }} />
            </div>
            <HowItWorks color="#16a34a" steps={['Package select karo', '"Request Bhejo" click karo', 'Admin ko WhatsApp jaayega', 'Payment karo', 'Blast ho jaayega!']} />
            {!blastRequested ? (
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '16px', fontSize: '16px' }} onClick={handleBlastRequest} disabled={blastSubmitting || !selectedPackage}>
                {blastSubmitting ? '⏳...' : selectedPackage ? `📱 Request Bhejo — ₹${BLAST_PACKAGES.find(p => p.id === selectedPackage)?.price}` : '👆 Pehle Package Select Karo'}
              </button>
            ) : <SuccessBox onReset={() => { setBlastRequested(false); setSelectedPackage(null); }} />}
          </div>
        )}

        {/* ════════════════════════════════════════════════
            ORIGINAL TAB: RUN ADS — untouched
            ════════════════════════════════════════════════ */}
        {activeTab === 'ads' && (
          <div>
            <div style={{ background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)', border: '1px solid #c4b5fd', borderRadius: '14px', padding: '20px', marginBottom: '24px' }}>
              <h3 style={{ color: '#5b21b6', margin: '0 0 8px' }}>📢 Instagram & Facebook Ads!</h3>
              <p style={{ color: '#6d28d9', margin: '0 0 12px', fontSize: '14px' }}>Admin tumhare liye professional ad chalayega — sirf package chuno aur payment karo!</p>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                {[{ icon: '🎯', text: 'Targeted audience' }, { icon: '🎨', text: 'Professional design' }, { icon: '📊', text: 'Real results' }, { icon: '💬', text: 'Admin support' }].map(f => (
                  <div key={f.text} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#5b21b6', fontWeight: 600 }}><span>{f.icon}</span><span>{f.text}</span></div>
                ))}
              </div>
            </div>
            <h3 style={{ marginBottom: '16px' }}>Ad Package Chuno:</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '14px', marginBottom: '24px' }}>
              {ADS_PACKAGES.map(pkg => <PackageCard key={pkg.id} pkg={pkg} selected={selectedAd} onSelect={setSelectedAd} />)}
            </div>
            <HowItWorks color="#7c3aed" steps={['Package select karo', '"Ad Request Bhejo" click karo', 'Admin ko WhatsApp jaayega', 'Payment karo', 'Admin professional ad banayega', 'Leads aana shuru!']} />
            {!adRequested ? (
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '16px', fontSize: '16px', background: 'linear-gradient(135deg, #7c3aed, #5b21b6)', border: 'none' }} onClick={handleAdRequest} disabled={adSubmitting || !selectedAd}>
                {adSubmitting ? '⏳...' : selectedAd ? `📢 Ad Request Bhejo — ₹${ADS_PACKAGES.find(p => p.id === selectedAd)?.price}` : '👆 Pehle Package Select Karo'}
              </button>
            ) : <SuccessBox onReset={() => { setAdRequested(false); setSelectedAd(null); }} />}
          </div>
        )}

        {/* ════════════════════════════════════════════════
            ORIGINAL TAB: PROFILE BOOST — untouched
            ════════════════════════════════════════════════ */}
        {activeTab === 'boost' && (
          <div>
            <div style={{ background: 'linear-gradient(135deg, #fef9c3, #fef3c7)', border: '1px solid #fcd34d', borderRadius: '14px', padding: '20px', marginBottom: '24px' }}>
              <h3 style={{ color: '#92400e', margin: '0 0 8px' }}>⭐ Profile Boost — Top Pe Aao!</h3>
              <p style={{ color: '#b45309', margin: '0 0 12px', fontSize: '14px' }}>Featured listing se zyada clients tumhari profile dekhenge!</p>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                {[{ icon: '🔝', text: 'Top placement' }, { icon: '⭐', text: 'Featured badge' }, { icon: '👁️', text: '5x zyada views' }, { icon: '📈', text: 'Zyada bookings' }].map(f => (
                  <div key={f.text} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#92400e', fontWeight: 600 }}><span>{f.icon}</span><span>{f.text}</span></div>
                ))}
              </div>
            </div>
            <div style={{ background: decorator?.isFeatured ? '#ecfdf5' : '#f8fafc', border: `1px solid ${decorator?.isFeatured ? '#6ee7b7' : '#e2e8f0'}`, borderRadius: '12px', padding: '14px 18px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '24px' }}>{decorator?.isFeatured ? '⭐' : '😐'}</span>
              <div>
                <strong style={{ color: decorator?.isFeatured ? '#059669' : '#64748b' }}>{decorator?.isFeatured ? 'Tumhara profile Featured hai! ✅' : 'Abhi Featured nahi ho'}</strong>
                <p style={{ margin: '2px 0 0', fontSize: '13px', color: '#94a3b8' }}>{decorator?.isFeatured ? 'Top mein dikh raha hai' : 'Boost karo — top pe aao!'}</p>
              </div>
            </div>
            <h3 style={{ marginBottom: '16px' }}>Boost Package Chuno:</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '14px', marginBottom: '24px' }}>
              {BOOST_PACKAGES.map(pkg => <PackageCard key={pkg.id} pkg={pkg} selected={selectedBoost} onSelect={setSelectedBoost} />)}
            </div>
            <HowItWorks color="#b45309" steps={['Package select karo', '"Boost Request Bhejo" click karo', 'Admin ko WhatsApp jaayega', 'Payment karo', 'Profile Featured ho jaayegi', 'Decorators list mein top pe!']} />
            {!boostRequested ? (
              <button className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '16px', fontSize: '16px', background: 'linear-gradient(135deg, #b45309, #92400e)', border: 'none' }} onClick={handleBoostRequest} disabled={boostSubmitting || !selectedBoost}>
                {boostSubmitting ? '⏳...' : selectedBoost ? `⭐ Boost Request Bhejo — ₹${BOOST_PACKAGES.find(p => p.id === selectedBoost)?.price}` : '👆 Pehle Package Select Karo'}
              </button>
            ) : <SuccessBox onReset={() => { setBoostRequested(false); setSelectedBoost(null); }} />}
          </div>
        )}

      </div>
    </div>
  );
}